function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Wizard } from 'react-use-wizard';
import { START_TRIAL_MODAL } from '../../../../components/modal/StartTrialModal/StartTrialModal';
import { getUserProfile, showModal } from '../../../../redux/actions';
import { client } from '../../../../utilities/api';
import { getUser, isImpersonating, setUser } from '../../../../utilities/storage';
import { isUserAnonymous, userHasValidMembership } from '../../../../utilities/user';
import { onboardingConstants } from './constants';
import Profession from './Profession';
import { OnboardingProvider, useOnboarding } from './reducer';
import Welcome from './Welcome';
var Onboarding = function() {
    var _useOnboarding = _sliced_to_array(useOnboarding(), 2), onboardingDispatch = _useOnboarding[1];
    var dispatch = useDispatch();
    var _useState = _sliced_to_array(useState(false), 2), open = _useState[0], setOpen = _useState[1];
    var _useSelector = useSelector(function(state) {
        return {
            userProfile: state.profileReducer.userProfile,
            userProfileState: state.profileReducer.userProfileState
        };
    }), userProfile = _useSelector.userProfile, userProfileState = _useSelector.userProfileState;
    var isUserLoggedIn = useSelector(function(state) {
        return state.profileReducer.isUserLoggedIn;
    });
    var hasOnboarded = userProfile.full_name && userProfile.profession;
    useEffect(function() {
        if (isUserLoggedIn && !hasOnboarded && !isUserAnonymous(userProfile)) {
            if (userProfile === null || userProfile === void 0 ? void 0 : userProfile.full_name) {
                onboardingDispatch({
                    type: onboardingConstants.SET_FULL_NAME,
                    payload: userProfile.full_name
                });
            }
            if (!isImpersonating()) {
                setOpen(true);
            }
        }
    }, [
        userProfile,
        isUserLoggedIn,
        hasOnboarded,
        userProfileState,
        onboardingDispatch
    ]);
    var onSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(userDetails) {
            var user, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            client.onboardUser({
                                fullName: userDetails.fullName,
                                phoneNumber: userDetails.phoneNumber,
                                profession: userDetails.profession,
                                isMarketingEnabled: userDetails.isMarketingEnabled
                            }, process.env.STRIPE_ONBOARD_COUPON_ID // always grant New Customer Discount
                            )
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            dispatch(getUserProfile())
                        ];
                    case 2:
                        _state.sent();
                        setOpen(false);
                        if (!userHasValidMembership(userProfile)) {
                            dispatch(showModal(START_TRIAL_MODAL));
                        }
                        user = getUser();
                        user['full_name'] = userDetails.fullName;
                        setUser(user);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        setOpen(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(userDetails) {
            return _ref.apply(this, arguments);
        };
    }();
    var onHide = function() {
        setOpen(false);
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        id: "onboarding-modal",
        show: open,
        onHide: onHide,
        backdrop: "static",
        keyboard: false,
        centered: true
    }, /*#__PURE__*/ React.createElement(Wizard, null, /*#__PURE__*/ React.createElement(Welcome, null), /*#__PURE__*/ React.createElement(Profession, {
        onSubmit: onSubmit
    })));
};
var WithOnboardingProvider = function() {
    return /*#__PURE__*/ React.createElement(OnboardingProvider, null, /*#__PURE__*/ React.createElement(Onboarding, null));
};
export default WithOnboardingProvider;
